import React from 'react'
import { string, bool, func, oneOfType, object, node } from 'prop-types'
import classNames from 'classnames'

export const BTN_TYPES = { PRIMARY: 'PRIMARY', OUTLINE: 'OUTLINE' }

const Button = ({
  label,
  children,
  type,
  btnStyle = BTN_TYPES.PRIMARY,
  disabled,
  onClickHandler,
  mainClass = 'nft-form-btn',
  customClasses = '',
  active,
  withIcon,
  insightsValues,
  ...rest
}) => {
  const btnClasses = classNames(mainClass,
    {
      'afd-btn--full afd-btn': btnStyle === BTN_TYPES.PRIMARY,
      'nft-form-btn--outline': btnStyle === BTN_TYPES.OUTLINE,
      'nft-form-btn--outline--active': active && btnStyle === BTN_TYPES.OUTLINE,
      'nft-form-btn--with-icon': withIcon
    })
  return (
    <button type={type}
      onClick={onClickHandler || null}
      className={btnClasses}
      disabled={disabled}
      {...insightsValues}
      {...rest}>
      {children || label}
    </button>
  )
}

Button.propTypes = {
  label: string,
  children: node,
  type: string,
  disabled: bool,
  onClickHandler: oneOfType([func, bool]),
  mainClass: string,
  customClasses: string,
  active: bool,
  withIcon: bool,
  insightsValues: object
}

export default Button